import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PopUp from '../../../../Shared/Popup/PopUp';
import Config from '../../../../../Config';

const ViewingOption = (props) => {
    const [isDisplayPopup, setIsDisplayPopup] = useState(false);

    return (
        <div className='viewing-option'>

            <div className='viewing-option-wrapper'>

                <div>
                    <input type='radio' name='viewing-option' className='input-radio' id='input-radio-app' />
                    <label className='viewing-option-item' htmlFor='input-radio-app' onClick={() => props.onSelectedViewingOption('app')}>
                        אין לי צורך בממיר
                    </label>
                </div>

                <div>
                    <input type='radio' name='viewing-option' className='input-radio' id='input-radio-tv' />
                    <label className='viewing-option-item' htmlFor='input-radio-tv' onClick={() => props.onSelectedViewingOption('tv')}>
                        אני רוצה ממיר אחד או יותר
                    </label>
                </div>

                {props.errorMsg && <div className='error-msg'>{props.errorMsg}</div>}

            </div>

            {
                props.supportedTvPopupText &&
                <div className='open-popup-link-wrapper'>
                    <div className='open-popup-image'> <Image src={Config.epiBaseUrl + props.supportedTvImage} /> </div>
                    <div className='open-popup-link'>
                        <a href='#' onClick={() => setIsDisplayPopup(true)}>
                            האם הטלוויזיה שלי נתמכת?
                        </a>
                    </div>

                    <PopUp showPopUp={isDisplayPopup} onClose={() => setIsDisplayPopup(false)} footerBtn={{ text: 'הבנתי, תודה', onBtnClick: handleClosePopup }}>
                        <div className='popup-title'>האם הטלוויזיה שלי נתמכת</div>
                        <div className='popup-image'><Image src={Config.epiBaseUrl + props.supportedTvImage} /></div>
                        <div dangerouslySetInnerHTML={{ __html: props.supportedTvPopupText }}></div>
                    </PopUp>
                </div>
            }

        </div >
    );

    function handleClosePopup() {
        setIsDisplayPopup(false);
    }

};

const mapStateToProps = (state) => {
    return {
        totalPrice: state.saleJetBlock.totalPrice,
    };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(ViewingOption);
